/**
 * Platform Admin → Şablonlar. Global EXPO To-Do şablon editörü.
 * Editör mantığı ExpoTemplates ile ortak — mode="global" ile
 * /api/admin/expo-templates uçlarına yazar ve tüm tenant'lara yayılır.
 */
import ExpoTemplates from "../expo/ExpoTemplates";

export default function PlatformTemplates() {
  return (
    <div data-testid="platform-templates-page">
      <ExpoTemplates mode="global" />
    </div>
  );
}
